import dayjs from 'dayjs';

import * as DataPattern from '../constants/DataPattern';

export const formatDatetoRO = (dateToFormat) => {
    var formattedDate;

    if( !dateToFormat || dateToFormat.trim().length === 0 ) {
        formattedDate = '';
    }
    else{
        formattedDate = dayjs(dateToFormat).format(DataPattern.DATE_FORMAT_RO);
    }
    return formattedDate;
}

export const formatDateTimetoRO = (dateToFormat) => {
    var formattedDate;

    if( !dateToFormat || dateToFormat.trim().length === 0 ) {
        formattedDate = '';
    }
    else{
        formattedDate = dayjs(dateToFormat).format(DataPattern.DATE_TIME_FORMAT_RO);
    }
    return formattedDate;
}